"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var MemberType_1 = require("./MemberType");
var ArrayUtils_1 = require("../lib/ArrayUtils");
var _2024_6_30 = new Date(2024, 5, 30, 12, 0, 0).getTime();
var _2025_6_30 = new Date(2025, 5, 30, 12, 0, 0).getTime();
var _2026_6_30 = new Date(2026, 5, 30, 12, 0, 0).getTime();
var Employer = (function () {
    function Employer() {
        this._rateContribution = 0;
        this._rateContributionInSubsequentEmployment = 0;
        this._sgcMaximumContributionBase = null;
        this._enforceSGMaximumContributionBase = false;
        this._enforceSGCRatesOfContribution = false;
        this._employerContributionsHistory = [];
        this._arrayCounter = 0;
        this._deflatedEmployerContributions = [];
    }
    Employer.prototype.initialise = function (p, employerContributionRate, employerContributionRateInSubsequentEmployment, wageIndexation, arraySize) {
        this._enforceSGMaximumContributionBase = p.getParamBoolean("EnforceMaximumContributionBase");
        this._sgcMaximumContributionBase = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._sgcMaximumContributionBase.initialise(p.getParamNumber("SGCMaximumContributionBase"), wageIndexation);
        this._rateContribution = employerContributionRate;
        this._enforceSGCRatesOfContribution = p.getParamBoolean("EnforceSGCRatesOfContribution");
        this._rateContributionInSubsequentEmployment = employerContributionRateInSubsequentEmployment;
        this._employerContributionsHistory = ArrayUtils_1.InitialiseArray(arraySize + 2);
        this._arrayCounter = 0;
    };
    Employer.prototype.annualUpdate = function (year) {
        this._sgcMaximumContributionBase.index(year);
        this._arrayCounter++;
    };
    Employer.prototype.calculateEmployerContributions = function (salary, workload, projectionRunAsAt, yearCount, thisMemberType) {
        var startThisProjectionYear;
        var salaryForSuperannuation;
        var rateOfContribution;
        var sgRateOfContribution;
        if (this._enforceSGMaximumContributionBase) {
            salaryForSuperannuation = Math.min(salary * workload, 4 * this._sgcMaximumContributionBase.value);
        }
        else {
            salaryForSuperannuation = salary * workload;
        }
        startThisProjectionYear = projectionRunAsAt.plus(yearCount - 1);
        if (thisMemberType === MemberType_1.MemberType.ESSS_AssistMe_DB) {
            if (startThisProjectionYear.before(_2024_6_30)) {
                sgRateOfContribution = 0.08;
            }
            else if (startThisProjectionYear.before(_2025_6_30)) {
                sgRateOfContribution = 0.09;
            }
            else if (startThisProjectionYear.before(_2026_6_30)) {
                sgRateOfContribution = 0.11;
            }
            else {
                sgRateOfContribution = 0.12;
            }
        }
        else {
            if (startThisProjectionYear.before(_2024_6_30)) {
                sgRateOfContribution = 0.11;
            }
            else if (startThisProjectionYear.before(_2025_6_30)) {
                sgRateOfContribution = 0.115;
            }
            else {
                sgRateOfContribution = 0.12;
            }
        }
        if (this._enforceSGCRatesOfContribution) {
            rateOfContribution = Math.max(this._rateContribution, sgRateOfContribution);
        }
        else {
            rateOfContribution = this._rateContribution;
        }
        this._employerContributionsHistory[this._arrayCounter] = Math.round((salaryForSuperannuation * rateOfContribution * 100)) / 100;
    };
    Employer.prototype.commenceSubsequentEmployment = function () {
        this._rateContribution = this._rateContributionInSubsequentEmployment;
        this._enforceSGCRatesOfContribution = true;
    };
    Object.defineProperty(Employer.prototype, "employerContributions", {
        get: function () {
            return this._employerContributionsHistory[this._arrayCounter];
        },
        enumerable: true,
        configurable: true
    });
    Employer.prototype.getEmployerContributionsInYear = function (year) {
        return this._employerContributionsHistory[year - 1];
    };
    Employer.prototype.getDeflatedEmployerContributionsInYear = function (year) {
        return this._deflatedEmployerContributions[year - 1];
    };
    Employer.prototype.deflate = function (wageInflation, priceInflation, memberType, startAge, retirementAge) {
        var wageDeflationFactor = 1;
        var sunSuperFirstStateDeflationfactor = 1;
        var age = startAge + 1;
        this._deflatedEmployerContributions[0] = this._employerContributionsHistory[0];
        for (var i = 2; i <= this._employerContributionsHistory.length; i++) {
            wageDeflationFactor = wageDeflationFactor / (1 + wageInflation.getIndexationRate(i - 1));
            if (age > retirementAge) {
                sunSuperFirstStateDeflationfactor = sunSuperFirstStateDeflationfactor / (1 + priceInflation.getIndexationRate(i - 1));
            }
            else {
                sunSuperFirstStateDeflationfactor = sunSuperFirstStateDeflationfactor / (1 + wageInflation.getIndexationRate(i - 1));
            }
            if (memberType === MemberType_1.MemberType.ART_DEFAULT ||
                memberType === MemberType_1.MemberType.ART_LIFECYCLE ||
                memberType === MemberType_1.MemberType.FIRSTSTATESUPER ||
                memberType === MemberType_1.MemberType.FIRSTSTATESUPER_MYSUPER) {
                this._deflatedEmployerContributions[i - 1] = this._employerContributionsHistory[i - 1] * sunSuperFirstStateDeflationfactor;
            }
            else {
                this._deflatedEmployerContributions[i - 1] = this._employerContributionsHistory[i - 1] * wageDeflationFactor;
            }
            age++;
        }
    };
    return Employer;
}());
exports.Employer = Employer;
//# sourceMappingURL=Employer.js.map